function SliderCoursesBrief() {
	var swiperSlider = $('.js-slider-courses-brief');

	swiperSlider.each(function () {
		var options = $(this).data('options') || {},
			$parent = $(this).parent(),
			swiperDefaults = {
				slidesPerView: "auto",
				spaceBetween: 16,
				navigation: {
					nextEl: $parent.find('.js-slider-courses-brief-next')[0],
					prevEl: $parent.find('.js-slider-courses-brief-prev')[0],
				},
				pagination: {
					el: $parent.find('.js-slider-courses-brief-pagination')[0],
				},
				breakpoints: {
					// when window width is >= 768px
					768: {
						spaceBetween: 24,
					}
				}
			};

		var swiperOptions = $.extend(swiperDefaults, options),
			mySwiper = new Swiper(this, swiperOptions);
	});
}

export { SliderCoursesBrief };